import CheckIcon from "@mui/icons-material/Check";
import { Box, Typography } from "@mui/material";

interface GuestModalStepperProps {
  activeStep: 1 | 2;
}

const STEPS = [
  { number: 1, label: "Guest Type" },
  { number: 2, label: "Details" },
] as const;

export const GuestModalStepper = ({ activeStep }: GuestModalStepperProps) => (
  <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "center", mb: 3 }}>
    {STEPS.map((step, index) => {
      const isCompleted = step.number < activeStep;
      return (
        <Box key={step.number} sx={{ display: "flex", alignItems: "flex-end" }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, whiteSpace: "nowrap", px: 1 }}>
              {step.label}
            </Typography>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                border: 1,
                borderColor: "info.main",
                bgcolor: isCompleted ? "info.main" : "grey.100",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {isCompleted ? (
                <CheckIcon sx={{ fontSize: 16, color: "common.white" }} />
              ) : (
                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 14, color: "info.main" }}>
                  {step.number}
                </Typography>
              )}
            </Box>
          </Box>
          {index < STEPS.length - 1 && <Box sx={{ width: 64, height: "1px", bgcolor: "grey.300", mb: "12px" }} />}
        </Box>
      );
    })}
  </Box>
);
